<template>
    <div class="index">
        <div class="index-suspension" v-if="suspension">
            <img src="../../content/images/suspension-close.png" style="cursor: pointer"
                 @click="handleSuspensionClose()"/>
            <img src="../../content/images/suspension.png" style="cursor: pointer" @click="handleGO()"/>
        </div>
        <div class="festival">
            <ad type="pcIndex"></ad>
        </div>
        <div class="index-content">
            <h1 class="title">测测您的网站营销力</h1>
            <!--<iframe src="https://zhidao.baidu.com" id="iframe"></iframe>-->
            <div class="input-box">
                <input
                    class="main-input"
                    type="text"
                    placeholder="请输入您的网址"
                    v-model="url"
                    @keyup="urlChange"
                    @mousedown="urlChange"
                    @mouseout="urlChange"
                    @keyup.enter="beforeStart()">
                <!--<img class="forfree" src="../../content/images/forfree.png" alt="免费">-->
            </div>
            <div class="submit-box">
                <el-button class="main-btn" type="primary" @click="beforeStart()" v-show="!isQueue"
                           v-bd-track-event="['营销力诊断', '点击立即诊断']">
                    立即诊断
                </el-button>
                <div v-if="user._id">
                    <p class="count color-f2" v-if="isVip==='no-vip'">剩<span>{{checkCount}}</span>次</p>
                    <div class="submit-btn-vip" v-else><img src="../../content/images/member/member-vip-free-icon.png">
                    </div>
                </div>

                <queue-progress v-show="isQueue" ref="queue"></queue-progress>
            </div>
        </div>

        <!-- 累计页面数 -->
        <page-number></page-number>

        <!-- 老板工具入口 -->
        <!--<toolkit></toolkit>-->

        <!-- 温馨提示弹窗 -->
        <prompt-dialog :params="warmHintDialog" @start="checkStart"></prompt-dialog>

        <!-- 诊断次数弹框 -->
        <count-dialog :visible.sync="countDialog.visible"
                      :title="countDialog.title"
                      :btn-text="countDialog.btnText" @confirm="toInfoTask()">
            <div class="color-f2" v-html="countDialog.content">完善个人信息和企业信息，可额外奖励<span class="success"> 2次 </span>诊断机会
            </div>
        </count-dialog>
        <member-check @isShow="isShow" v-if="display"></member-check>
        <activity></activity>

    </div>
</template>

<script>
    import {mapState, mapGetters, mapMutations, mapActions} from 'vuex'
    import Validate from '../../store/validate'
    import queueProgress from './components/QueueProgress'
    import pageNumber from './PageNumber'
    import promptDialog from './PromptDialog'
    import countDialog from '../../components/DialogOperate'
    import ad from './components/Ad'
    import activity from './Activity'
    import memberCheck from '../member/memberCheck.vue'

    export default {
        components: {
            queueProgress,
            pageNumber,
            promptDialog,
            countDialog,
            activity,
            ad,
            memberCheck
        },
        data() {
            return {
                url: '',
                warmHintDialog: {
                    visible: false,
                    checked: false
                },
                countDialog: {
                    visible: false,
                    type: 1,
                    title: '',
                    btnText: '',
                    content: ''
                },
                display: false,
                suspension: true,
                welfareId: ''
            }
        },
        computed: {
            ...mapState(['user']),
            ...mapState('check', ['isQueue']),
            ...mapGetters(['currentUser', 'storageCacheUrl', 'urlFormat', 'isVip']),
            ...mapGetters('qiniu', ['getFileUrl']),
            checkCount() {
                console.log(this.user)
                if (this.user.freeCheckCount || this.user.extraCheckCount) {
                    return this.user.freeCheckCount + this.user.extraCheckCount;
                } else {
                    return 0;
                }
            }
        },
        created() {
            this.url = this.storageCacheUrl();
            this.urlChange();
            this.warmHintDialog.checked = window.localStorage['webchecker-warmhint'] === 'true';

        },
        methods: {
            ...mapMutations('check', ['reset']),
            ...mapMutations(['setLoginStepLogin', 'bdTrackEvent']),
            ...mapActions('check', ['start', 'startOther']),
            ...mapActions('task', ['isFinishTask', 'canFinishTask']),
            ...mapActions('welfare', ['getTaskList']),
            handleSuspensionClose() {
                this.suspension = false
            },
            handleGO() {
                window.location.href = "https://yingxiao.xuanwo001.com/#/member?hmsr=%E9%A6%96%E9%A1%B5%E6%82%AC%E6%B5%AEbanner&hmpl=&hmcu=&hmkw=&hmci="
            },
            isShow(val) {
                this.display = val;
            },
            //检测前的校验
            beforeStart() {
                this.url = this.url || '';

                if (!this.url) {
                    this.$message.error('请输入网址');
                    return;
                }
                if (!Validate.validateUrl(this.url)) {
                    this.$message.error('请输入正确的网址');
                    return;
                }
                let dotLength = 2;
                if (/.+(\.com\.cn|\.net\.cn|\.gov\.cn)$/i.test(this.url)) {
                    dotLength = 3;
                }
                if (this.url.split('.').length === dotLength && !/^www\./i.test(this.url)) {
                    this.url = 'www.' + this.url;
                }
                if (this.isWarmHint()) return;

                this.checkStart();

            },
            // 启动检测
            checkStart() {
                let url = this.url.toLowerCase();
                url = Validate.getDomain(url);
                this.storageCacheUrl(url);
                this.setWarmHint();
                this.reset();
                if (!this.currentUser.phone) {
                    this.startOther({url}).then(res => {
                        console.log(res)
                        this.$router.push({
                            name: 'detail',
                            query: {url}
                        });
                    }, err => {
                        this.errorHandle(err);
                    })
                } else {
                    this.start({url}).then(res => {
                        this.$router.push({
                            name: 'detail',
                            params: {token: res.token},
                            query: {url}
                        });
                    }, err => {
                        this.errorHandle(err);
                    })
                }

            },
            // 错误处理
            errorHandle(err = {}) {
                let alertOptions = {
                    customClass: 'sys-hint',
                    confirmButtonText: '知道了'
                };
                switch (err.errorCode) {
                    case 1:
                        this.$alert(err.errorMsg, '提示', alertOptions);
                        break;
                    case 2:
                        this.$refs.queue.isQueueUp();
                        break;
                    case 3:
                        this.isCheckCount();
                        break;
                    default:
                        this.$alert(err || '启动失败', '提示', alertOptions);
                        break;
                }
            },
            //是否还有检测次数
            async isCheckCount() {
                if (this.isVip === 'no-vip') {
                    let welfare = await this.getTaskList();
                    console.log(welfare, 777)
                    this.welfareId = welfare._id;
                    console.log(this.welfareId, 44)
                    this.isFinishTask(this.welfareId).then(() => {
                        this.countDialog = {
                            visible: true,
                            type: 1,
                            title: '您今天的免费诊断次数已用完了哦',
                            btnText: '去完善信息',
                            content: '完善个人信息和企业信息，可额外奖励<span class="success"> 2次 </span>诊断机会'
                        }
                    }, () => {
                        this.bdTrackEvent(['首页', '立即开通会员（诊断提示）'])
                        this.display = true
                        /* this.countDialog = {
                             visible: true,
                             type: 2,
                             title: '您今天的免费诊断次数已用完',
                             btnText: '我知道了',
                             content: '明天再来，可重新获得<span class="success"> 1次 </span>免费诊断机会'
                         }*/
                    })
                }

            },
            //完善信息任务
            toInfoTask() {
                if (this.countDialog.type === 2) return;
                this.canFinishTask('perfect-info').then(() => {
                    this.$router.push({name: 'user-basic'})
                }, err => {
                    if (err === 'notUserInfo') {
                        this.$router.push({name: 'user-basic'})
                    } else {
                        this.$router.push({name: 'user-company'})
                    }
                })
            },
            //是否需要弹窗温馨提示
            isWarmHint() {
                let isWarm = !this.warmHintDialog.checked;
                if (isWarm) {
                    this.warmHintDialog.visible = true;
                }
                return isWarm;
            },
            setWarmHint() {
                window.localStorage['webchecker-warmhint'] = this.warmHintDialog.checked;
                this.warmHintDialog.visible = false;
            },
            //url格式化
            urlChange() {
                this.url = this.urlFormat(this.url);
            },
            //点击广告图
            onAdclick() {

            }
        }
    }
</script>

<style lang="scss" scoped>
    $headHeight: 11rem;
    .index {
        position: relative;
        height: 100%;
        text-align: center;
    }

    .index-suspension {
        width: 7.2rem;
        position: absolute;
        top: 40px;
        right: 39px;
    }

    .index-suspension img:nth-child(1) {
        width: 0.7rem;
        position: absolute;
        top: 0;
        right: 0;
    }

    .index-suspension img:nth-child(2) {
        width: 6.6rem;
        margin-top: 0.5rem;
    }

    .index-content {
        width: 100%;
    }

    .festival {
        width: 100%;
        padding: 3.5rem 0 .5rem;
    }

    .title {
        color: #1f1f20;
        font-size: 2.5rem;
        font-weight: normal;
        margin-top: 0;
    }

    .input-box {
        position: relative;
        width: 62.5%;
        height: 4rem;
        margin: 0 auto;
        box-shadow: 0 5px 10px rgba(0, 0, 0, .2);
    }

    .main-input {
        display: block;
        width: 100%;
        height: 100%;
        padding: 0 20px;
        font-size: 1.6rem;
        color: #33475f;
        border: 0;
        text-align: center;
        box-sizing: border-box;
    }

    .main-input::-webkit-input-placeholder {
        font-size: 20px;
        color: #bcbcbc;
    }

    .forfree {
        position: absolute;
        top: 0;
        right: 0;
        width: 6.5rem;
    }

    .submit-box {
        position: relative;
        width: 24rem;
        margin: 2.5rem auto 0;

        .submit-btn-vip {
            width: 3rem;
            position: absolute;
            left: -1px;
            top: 0px;
        }

        .count {
            position: absolute;
            right: -80px;
            bottom: 0;
            width: 60px;
            margin: 0;

            span {
                display: inline-block;
                width: 20px;
                height: 20px;
                line-height: 20px;
                margin: 0 4px;
                color: #fff;
                background-color: #60b0ee;
                border-radius: 50%;
            }
        }
    }

    .main-btn {
        display: block;
        width: 100%;
        height: 4rem;
        font-size: 1.5rem;
        font-family: "Microsoft YaHei";
    }
</style>



// WEBPACK FOOTER //
// app/view/index/Index.vue